"use client";

import React from "react";

export interface SynaptixLogoProps {
  size?: number | string;
  className?: string;
  showText?: boolean;
  subtitle?: string;
}

export const SynaptixLogo: React.FC<SynaptixLogoProps> = ({
  size = 40,
  className = "",
  showText = false,
  subtitle,
}) => {
  return (
    <div className={`flex items-center ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0 drop-shadow-[0_0_12px_rgba(0,229,255,0.35)]"
      >
        {/* Base Outer Circle */}
        <circle cx="50" cy="50" r="42" fill="none" stroke="#1A2A47" strokeWidth="2" />
        {/* Diagnostic Cyan Dotted Ring */}
        <circle
          cx="50"
          cy="50"
          r="32"
          fill="none"
          stroke="#00E5FF"
          strokeWidth="1.5"
          strokeDasharray="3 4"
        />
        {/* Orbital C-shaped Arc */}
        <path
          d="M 32,38 C 32,25, 68,25, 68,50 C 68,75, 32,75, 32,62"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="3.5"
          strokeLinecap="round"
        />
        {/* Top Cyan Node */}
        <circle cx="32" cy="38" r="4.5" fill="#00E5FF" />
        {/* Bottom White Node */}
        <circle cx="32" cy="62" r="4.5" fill="#FFFFFF" />
      </svg>
      {showText && (
        <div className="flex flex-col ml-3">
          <span className="font-grotesk font-bold text-xl text-white tracking-[3px]">
            SYNAPTIX
          </span>
          {subtitle && (
            <span className="text-[10px] font-medium text-cyan-400 tracking-widest uppercase">
              {subtitle}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default SynaptixLogo;
